module.exports = __webpack_public_path__ + "img/item_Story_02.9677e644.jpeg";